const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withContainerDims = require("../core/hoc/withContainerDims");
const AT = require("../core/vault/ActionTypes");
const MultiSlots = require("../core/vault/MultiSlots");
const MultiLoadGuard = require("../core/view/MultiLoadGuard");
const GradeChapter = require("../../shared/GradeChapter");
const {shallowEqOnKeys} = require("../core/util/SCUUtil");
const ReportStudentBody = require("./ReportStudentBody");
const ReportBodyHeader = require("./ReportBodyHeader");
const OpsLab = require("../lab/vault/OpsLab");

const styles = require("./styles/ReportMainBody.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const {
				gradeNumber,
				chapterNumber,
				blockNumber,
				studentIDs,
				typeID,
			} = props;
			const chapterIDs = GradeChapter.getChaptersForGrade(gradeNumber);
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const typeIDs = OpsLab.getAllTypeIDs();
			return {
				blocksObjLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.chapterBlocks(),
					chapterIDs
				),
				blocksObj: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.chapterBlocks(),
					chapterIDs
				),
				labBlocksObjLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.labBlocks(),
					typeIDs
				),
				labBlocksObj: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.labBlocks(),
					typeIDs
				),
				classGradeChapterLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportGradeChapter(),
					studentIDs
				),
				classGradeChapter: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportGradeChapter(),
					studentIDs
				),
				classChapterBlockLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportChapterBlock(chapterID),
					studentIDs
				),
				classChapterBlock: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportChapterBlock(chapterID),
					studentIDs
				),
				classBlockResultsLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportBlockResults(chapterID, blockNumber),
					studentIDs
				),
				classBlockResults: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportBlockResults(chapterID, blockNumber),
					studentIDs
				),
				classLabTypes: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportLabTypes(),
					studentIDs
				),
				classLabTypesLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportLabTypes(),
					studentIDs
				),
				classLabBlockResults: MultiSlots.getDataMany(
					vaultState,
					MultiSlots.table.reportLabBlockResults(typeID),
					studentIDs
				),
				classLabBlockResultsLoad: MultiSlots.getOldStyleStatus(
					vaultState,
					MultiSlots.table.reportLabBlockResults(typeID),
					studentIDs
				),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportClassStudents",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			classID: PT.number.isRequired,
			gradeNumber: PT.oneOfType([PT.string, PT.number]),
			chapterNumber: PT.oneOfType([PT.string, PT.number]),
			blockNumber: PT.oneOfType([PT.string, PT.number]),
			typeID: PT.oneOfType([PT.string, PT.number]),
			studentsData: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				windowWidth: PT.number,
			}).isRequired,
			studentIDs: PT.array.isRequired,
			blocksObj: PT.object.isRequired,
			blocksObjLoad: PT.object.isRequired,
			labBlocksObj: PT.object.isRequired,
			labBlocksObjLoad: PT.object.isRequired,
			classGradeChapterLoad: PT.object.isRequired,
			classGradeChapter: PT.object.isRequired,
			classChapterBlockLoad: PT.object.isRequired,
			classChapterBlock: PT.object.isRequired,
			classBlockResultsLoad: PT.object.isRequired,
			classBlockResults: PT.object.isRequired,
			classLabTypesLoad: PT.object.isRequired,
			classLabTypes: PT.object.isRequired,
			classLabBlockResultsLoad: PT.object.isRequired,
			classLabBlockResults: PT.object.isRequired,
		},

		shouldComponentUpdate: function(nextProps) {
			const p = [
				"classID",
				"gradeNumber",
				"chapterNumber",
				"blockNumber",
				"typeID",
				"blocksObj",
				"labBlocksObj",
				"classGradeChapter",
				"classChapterBlock",
				"containerDims",
			];
			return !shallowEqOnKeys(this.props, nextProps, p);
		},

		componentDidMount: function() {
			this.prevAllLoaded = false;
		},

		componentDidUpdate: function() {
			// Open printer dialog
			// TODO: Better way to know when images are loaded without using delay?
			// Also, this makes the print not as abrupt.
			if (this.allLoaded && !this.prevAllLoaded) {
				setTimeout(() => {
					window.print();
				}, 1000);
				this.prevAllLoaded = true;
			}
		},

		loadBlocks: function() {
			const {gradeNumber} = this.props;
			this.props.dispatch({
				type: AT.LOAD_CHAPTER_BLOCKS_SLOT_REQUEST,
				chapterIDs: GradeChapter.getChaptersForGrade(gradeNumber),
			});
		},

		loadGradeChapter: function() {
			this.props.dispatch({
				type: AT.LOAD_REPORT_GRADE_CHAPTER_SLOT_REQUEST,
				studentIDs: this.props.studentIDs,
			});
		},

		loadChapterBlock: function() {
			const {gradeNumber, chapterNumber, studentIDs, blocksObj} = this.props;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			const blocks = _.get(blocksObj, [chapterID, "blocks"], []);
			const testBlock = _.get(blocksObj, [chapterID, "testBlock"]);
			this.props.dispatch({
				type: AT.LOAD_REPORT_CHAPTER_BLOCK_SLOT_REQUEST,
				studentIDs,
				chapterID,
				blockIDs: _.map(blocks, b => b.id).concat([testBlock.id]),
			});
		},

		loadBlockResults: function() {
			const {gradeNumber, chapterNumber, blockNumber, studentIDs} = this.props;
			const chapterID = GradeChapter.toChapterID(
				gradeNumber,
				chapterNumber - 1
			);
			this.props.dispatch({
				type: AT.LOAD_REPORT_BLOCK_RESULTS_SLOT_REQUEST,
				studentIDs,
				chapterID,
				blockNumber,
			});
		},

		loadLabBlocks: function() {
			this.props.dispatch({
				type: AT.LOAD_TYPE_LAB_BLOCKS_SLOT_REQUEST,
				typeIDs: OpsLab.getAllTypeIDs(),
			});
		},

		loadLabTypes: function() {
			const {studentIDs} = this.props;
			this.props.dispatch({
				type: AT.LOAD_REPORT_LAB_TYPES_SLOT_REQUEST,
				studentIDs,
			});
		},

		loadLabBlockResults: function() {
			const {studentIDs, typeID} = this.props;
			this.props.dispatch({
				type: AT.LOAD_REPORT_LAB_BLOCK_RESULTS_SLOT_REQUEST,
				studentIDs,
				typeID,
			});
		},

		render: function() {
			const {
				gradeNumber,
				chapterNumber,
				blockNumber,
				typeID,
				containerDims,
				studentIDs,
				user,
				classID,
				pageData,
				studentsData,
			} = this.props;
			const w = containerDims.windowWidth;
			const hiddenColumns = [];
			// Hide different columns for different grades because # blocks won't fit
			if (w < 1160 || (gradeNumber > 3 && w < 1400)) {
				hiddenColumns.push("summary");
			}
			if (w < 1120 || (gradeNumber > 3 && w < 1320)) {
				hiddenColumns.push("played");
			}
			const sortedStudentIDs = _.sortBy(studentIDs, sid => [
				_.get(studentsData[sid], "user.lastName"),
				_.get(studentsData[sid], "user.firstName"),
				_.get(studentsData[sid], "user.displayName"),
			]);
			const availableLevels = _.uniq(_.map(studentsData, s => s.gradeID));
			const renderLoadedFinal = () => {
				this.allLoaded = true;
				return sortedStudentIDs.map(sid => {
					return (
						<div className={styles.singleStudent} key={"multistudent-" + sid}>
							<ReportBodyHeader
								user={user}
								filters={{}}
								updateFilter={() => {}}
								pageData={_.extend(
									{studentID: sid},
									_.omit(pageData, "classID")
								)}
								studentsData={studentsData}
								availableLevels={availableLevels}
							/>
							<ReportStudentBody
								user={user}
								studentID={sid}
								pageData={pageData}
								gradeNumber={gradeNumber}
								chapterNumber={chapterNumber}
								blockNumber={blockNumber}
								typeID={typeID}
								updateStudentFilter={() => {}}
								multiStudents={true}
								studentsData={studentsData}
							/>
						</div>
					);
				});
			};

			const chapterLG = {
				identifier: "reportGradeChapter-" + classID,
				status: this.props.classGradeChapterLoad,
				requestLoad: this.loadGradeChapter,
			};
			const blockResultsLG = {
				identifier: "reportBlockResults-" + classID + "-" + blockNumber,
				status: this.props.classBlockResultsLoad,
				requestLoad: this.loadBlockResults,
			};
			const blockLG = {
				identifier: "chapterBlocks-" + classID,
				status: this.props.blocksObjLoad,
				requestLoad: this.loadBlocks,
			};

			const typesLG = {
				identifier: "reportStudentLabTypes" + classID,
				status: this.props.classLabTypesLoad,
				requestLoad: this.loadLabTypes,
			};
			const labBlockResultsLG = {
				identifier:
					"reportclassLabBlockResults-" + classID + "-" + (typeID || 0),
				status: this.props.classLabBlockResultsLoad,
				requestLoad: this.loadLabBlockResults,
			};
			const labBlockLG = {
				identifier: "classLabTypeBlocks-" + classID + "-" + (typeID || 0),
				status: this.props.labBlocksObjLoad,
				requestLoad: this.loadLabBlocks,
			};

			// Which load guards do we need? Same things as in ReportStudentBody
			let guards = [];
			if (gradeNumber === "lab") {
				if (typeID) {
					guards = [labBlockLG, labBlockResultsLG];
				} else if (gradeNumber === "lab") {
					guards = [labBlockLG, typesLG];
				} else {
					guards = [typesLG];
				}
			} else if (blockNumber || chapterNumber || gradeNumber) {
				guards = [
					blockLG,
					chapterNumber || blockNumber ? blockResultsLG : chapterLG,
				];
			} else {
				guards = [chapterLG];
			}
			return (
				<div className={styles.main}>
					<MultiLoadGuard
						guardList={guards}
						loadingView="logo"
						logoColorType="color"
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={renderLoadedFinal}
					/>
				</div>
			);
		},
	})
);
